import { css, SerializedStyles } from '@emotion/core';
import { Theme } from './theme';

// Typeography mixins based on Material UI Type Scale System:
// https://material.io/design/typography/#type-scale

export const normalText = (theme: Theme): SerializedStyles => css`
  ${theme.mui.typography.body1}
  color: ${theme.mui.palette.text.primary};
`;

export const titleText = (theme: Theme): SerializedStyles => css`
  ${theme.mui.typography.h5}
  color: ${theme.mui.palette.text.primary};
`;

export const subtitleText = (theme: Theme): SerializedStyles => css`
  ${theme.mui.typography.subtitle1}
  color: ${theme.mui.palette.text.secondary};
`;

export const helpText = (theme: Theme): SerializedStyles => css`
  ${theme.mui.typography.caption}
  color: ${theme.mui.palette.text.secondary};
`;

export const contentContainer = (theme: Theme): SerializedStyles => css`
  margin-top: ${theme.mui.spacing(theme.embedded ? 0 : 8)}px;
`;
